import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { App, PreziData } from '../../GalleryPage/App';
import { CategoryData } from '../../App';


interface GalleryRootProps {
    categories: Array<CategoryData>;
    prezis: Array<PreziData>;
    categoryString: string;
    headerColor: string;
    activeGalleryTab: string;
    presentationsTabString: string;
    videosTabString: string;
    designTabString: string;
}

const GalleryRoot: React.FunctionComponent<GalleryRootProps> = (props: GalleryRootProps) => {
    return (
        <BrowserRouter>
            <App
                categories = { props.categories }
                prezis = { props.prezis }
                categoryString = { props.categoryString }
                headerColor = { props.headerColor }
                activeGalleryTab = { props.activeGalleryTab }
                presentationsTabString = { props.presentationsTabString }
                videosTabString = { props.videosTabString }
                designTabString = { props.designTabString }
            />
        </BrowserRouter>
    );
};

export default GalleryRoot;



// WEBPACK FOOTER //
// ./assets/js/components/rootComponents/GalleryRoot.tsx